import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import CloseIcon from "@material-ui/icons/Close";
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@material-ui/core/IconButton";
import { green, red } from "@material-ui/core/colors";
import LoadableComponent from "../Loading/LoadableComponent";

interface IProps {
  open: boolean;
  onClose: any;
  onAccept?: Function;
  title: string;
  children: any;
  wide?: boolean;
  loading?: boolean;
  onAdditionalAction?: Function;
  overrideClose?: Function;
  fullScreen?: boolean;
  hideClose?: boolean;
  cancelText?: string;
  disabledAccept?: boolean;
  additionalButtonText?: any;
  showTitle?: boolean;
  acceptText?: any;
  hideActions?: boolean;
  showAdditionalButton?: boolean;
  forceTop?: boolean;
  backgroundColor?: string;
}

const useStyles = makeStyles({
  icon: {
    position: "absolute",
    right: "2%",
    top: "2%",
  },
  fullScreen: {
    marginTop: "-4%",
    height: "9vh",
  },
  buttons: {
    height: "6vh",
  },
  danger: {
    backgroundColor: red[500],
    color: "white",
    "&:hover": {
      backgroundColor: red[700],
    },
  },
  success: {
    backgroundColor: green[500],
    color: "white",
    "&:hover": {
      backgroundColor: green[700],
    },
  },
});

const FormDialog: React.FC<IProps> = ({
  open,
  onClose,
  onAccept,
  title,
  children,
  wide = false,
  overrideClose,
  loading = false,
  fullScreen = false,
  hideClose = false,
  cancelText = "Anuluj",
  acceptText = "Akceptuj",
  hideActions = false,
  disabledAccept = false,
  showAdditionalButton = false,
  showTitle = true,
  additionalButtonText = "",
  onAdditionalAction = () => {},
  forceTop = false,
  backgroundColor = "#fff",
}: IProps) => {
  const classes = useStyles();

  return (
    <Dialog
      style={{ zIndex: forceTop ? 2000 : 1300 }}
      fullScreen={fullScreen}
      maxWidth={wide ? "md" : "sm"}
      fullWidth
      open={open}
      onClose={onClose}
      PaperProps={{ style: { backgroundColor: backgroundColor } }}
    >
      {showTitle && (
        <React.Fragment>
          {!hideClose && (
            <IconButton className={classes.icon} edge="start" color="inherit" onClick={onClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          )}
          <DialogTitle>{title}</DialogTitle>
        </React.Fragment>
      )}
      <LoadableComponent loading={loading}>
        <React.Fragment>
          <DialogContent>{children}</DialogContent>
          {!hideActions && (
            <DialogActions>
              <ButtonGroup fullWidth className={!fullScreen ? classes.buttons : ""} color="primary">
                {onAccept && (
                  <Button
                    type={"submit"}
                    disabled={disabledAccept}
                    className={`${fullScreen ? classes.fullScreen : ""} ${classes.success}`}
                    variant={"contained"}
                    onClick={() => onAccept()}
                  >
                    {acceptText}
                  </Button>
                )}

                {showAdditionalButton && (
                  <Button className={fullScreen ? classes.fullScreen : ""} onClick={() => onAdditionalAction()}>
                    {additionalButtonText}
                  </Button>
                )}
                <Button
                  variant={"contained"}
                  className={`${fullScreen ? classes.fullScreen : ""} ${classes.danger}`}
                  onClick={overrideClose ? overrideClose : onClose}
                >
                  {cancelText}
                </Button>
              </ButtonGroup>
            </DialogActions>
          )}
        </React.Fragment>
      </LoadableComponent>
    </Dialog>
  );
};

export default FormDialog;
